import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    id: 0,
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    fechaApertura: moment(new Date()).format('YYYY-MM-DD'),
    fechaCierre: moment(new Date()).format('YYYY-MM-DD'),
    numeroInicial: 0,
    numeroFinal: 0,
    rowVersion: null,
    
    bancoChequeraDatos: [],

    bancoChequeraCheques: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_CHEQUERA'(state, bancoChequeraId) {
        state.id = bancoChequeraId;
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.fechaApertura = '1900-01-01';
        state.fechaCierre = '1900-01-01';
        state.numeroInicial = 0;
        state.numeroFinal = 0;
        state.rowVersion = null;
    },
    'SET_BANCO_CHEQUERA'(state, bancoChequera) {
        state.bancoCuentaId = (bancoChequera.bancoCuenta) ? bancoChequera.bancoCuenta.id : 0;
        state.bancoCuenta = bancoChequera.bancoCuenta;
        state.bancoCuentaNombre = (bancoChequera.bancoCuenta) ? bancoChequera.bancoCuenta.nombre.trim() : null;
        state.fechaApertura = moment(bancoChequera.fechaApertura).format('YYYY-MM-DD');
        state.fechaCierre = moment(bancoChequera.fechaCierre).format('YYYY-MM-DD');
        state.numeroInicial = bancoChequera.numeroInicial;
        state.numeroFinal = bancoChequera.numeroFinal;
        state.rowVersion = bancoChequera.rowVersion;
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuenta = bancoCuenta;
        state.bancoCuentaId = bancoCuenta ? bancoCuenta.id : 0;
        state.bancoCuentaNombre = bancoCuenta ? bancoCuenta.nombre.trim() : null;
    },

    'INICIALIZAR_BANCO_CHEQUERA_DATOS' (state) {
        state.bancoChequeraDatos = [];
    },
    'SET_BANCO_CHEQUERA_DATOS' (state, params) {
        state.bancoChequeraDatos = params.bancoChequeraDatos;
    },

    'INICIALIZAR_BANCO_CHEQUERA_CHEQUES' (state) {
        state.bancoChequeraCheques = [];
    },
    'SET_BANCO_CHEQUERA_CHEQUES' (state, params) {
        state.bancoChequeraCheques = params.bancoChequeraCheques;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoChequeraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CHEQUERA', bancoChequeraId);

            if (bancoChequeraId != 0) {
                apiAxios.get('bancoschequeras/' + bancoChequeraId + '/abm' ) 
                    .then(res => {
                        commit('SET_BANCO_CHEQUERA', res.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);            
                    })
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let bancoChequera = {
                bancoCuentaId: parseInt(state.bancoCuentaId),
                bancoCuenta: parseInt(state.bancoCuenta),
                fechaApertura: moment(state.fechaApertura).format('YYYY-MM-DD'),
                fechaCierre: moment(state.fechaCierre).format('YYYY-MM-DD'),
                numeroInicial: parseInt(state.numeroInicial),
                numeroFinal: parseInt(state.numeroFinal),
            }

            let url = 'bancoschequeras';
            if (state.id != 0) {
                bancoChequera.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, bancoChequera)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    setBancoCuenta: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },

    getBancoChequeraDatos ( { commit }, bancoChequeraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CHEQUERA_DATOS');

            if (bancoChequeraId != 0) {
                apiAxios.get('bancoschequeras/' + bancoChequeraId ) 
                .then(res => {
                    let bancoChequeraDatos = [
                        { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                        // { 'nombre': 'fechaApertura', 'campo': 'Fecha Apertura', 'valor': res.data.fechaApertura, 'formato': 'fecha' },
                        // { 'nombre': 'fechaCierre', 'campo': 'Fecha Cierre', 'valor': res.data.fechaCierre, 'formato': 'fecha' },
                        { 'nombre': 'numeroInicial', 'campo': 'Número Inicial', 'valor': res.data.numeroInicial, 'formato': '' },
                        { 'nombre': 'numeroFinal', 'campo': 'Número Final', 'valor': res.data.numeroFinal, 'formato': '' },
                    ];
                    
                    let params = {
                        bancoChequeraDatos 
                    }
                    commit('SET_BANCO_CHEQUERA_DATOS', params);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
    getBancoChequeraCheques ( { commit }, bancoChequeraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CHEQUERA_CHEQUES');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (bancoChequeraId != 0) {
                apiAxios.get('bancoschequeras/' + bancoChequeraId + '/cheques' + queryString) 
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    let params = {
                        bancoChequeraCheques: res.data
                    }
                    commit('SET_BANCO_CHEQUERA_CHEQUES', params);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}